import { AppBar, Toolbar, Box } from "@mui/material";
import headerStyles from "./headerStyle";
import logo from "../../logo.svg";

const Header = () => {
  return (
    <AppBar position="static" sx={headerStyles.appBar}>
      <Toolbar sx={headerStyles.toolbar}>
        <img
          src={logo}
          alt="Naturgy"
          style={{ height: 30 }}
        />
        <Box sx={{ flexGrow: 1 }} />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
